// Source/Product-Sticky-Media/mod.ts
var mobile = matchMedia("(max-width: 749px)");
var COLLAPSED_KEY = "steda-sticky-media-collapsed";
for (const section of document.querySelectorAll(".product-page--sticky-media"))
  setup(section);
document.addEventListener("shopify:section:load", (event) => {
  const section = event.target.querySelector(".product-page--sticky-media");
  if (section)
    setup(section);
});
function setup(section) {
  const viewer = section.querySelector('[id^="GalleryViewer"]');
  const list = viewer?.querySelector(".product__media-list");
  const anchor = section.querySelector(".product__media-sticky-anchor");
  if (!viewer || !list || !anchor)
    return;
  let full = 0;
  let listHeight = 0;
  let frame = 0;
  const measure = () => {
    viewer.classList.remove("is-shrunk");
    full = viewer.offsetHeight;
    listHeight = list.offsetHeight;
    update();
  };
  const update = () => {
    frame = 0;
    const stuck = -anchor.getBoundingClientRect().top;
    viewer.classList.toggle("is-stuck", mobile.matches && stuck > 0.5);
    const limit = full - innerHeight / 3;
    const shrink = Math.min(stuck, limit, listHeight - 1);
    if (!mobile.matches || shrink < 0.5) {
      viewer.classList.remove("is-shrunk");
    } else {
      viewer.style.setProperty("--sticky-media-full", `${full}px`);
      viewer.style.setProperty("--sticky-media-shrink", `${shrink}px`);
      viewer.style.setProperty("--sticky-media-scale", `${(listHeight - shrink) / listHeight}`);
      viewer.classList.add("is-shrunk");
    }
    if (viewer.classList.contains("is-stuck"))
      placeToggle();
  };
  const placeToggle = () => {
    const view = list.getBoundingClientRect();
    const middle = view.left + view.width / 2;
    let media;
    let closest = Infinity;
    for (const slide of list.querySelectorAll(".product__media-item")) {
      const box = slide.getBoundingClientRect();
      const distance = Math.abs(box.left + box.width / 2 - middle);
      if (distance < closest) {
        closest = distance;
        media = slide.querySelector("steda-viewer-3d, .product__media") ?? slide;
      }
    }
    if (!media)
      return;
    const edge = media.getBoundingClientRect().bottom - viewer.getBoundingClientRect().top;
    viewer.style.setProperty("--sticky-media-edge", `${edge}px`);
  };
  const schedule = () => {
    frame ||= requestAnimationFrame(update);
  };
  const toggle = viewer.querySelector(".product__media-sticky-toggle");
  const setCollapsed = (collapsed) => {
    viewer.classList.toggle("is-collapsed", collapsed);
    if (!toggle)
      return;
    toggle.setAttribute("aria-expanded", String(!collapsed));
    toggle.setAttribute("aria-label", (collapsed ? toggle.dataset.labelExpand : toggle.dataset.labelCollapse) ?? "");
  };
  setCollapsed(readCollapsed());
  toggle?.addEventListener("click", () => {
    const collapsed = !viewer.classList.contains("is-collapsed");
    setCollapsed(collapsed);
    storeCollapsed(collapsed);
  });
  addEventListener("scroll", schedule, { passive: true });
  addEventListener("resize", schedule);
  list.addEventListener("scroll", schedule, { passive: true });
  mobile.addEventListener("change", measure);
  new ResizeObserver(measure).observe(list);
  const header = document.querySelector(".Group-Header");
  if (header)
    new ResizeObserver(() => section.style.setProperty("--sticky-media-header", `${header.offsetHeight}px`)).observe(header);
}
function readCollapsed() {
  try {
    return sessionStorage.getItem(COLLAPSED_KEY) === "1";
  } catch {
    return false;
  }
}
function storeCollapsed(collapsed) {
  try {
    sessionStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0");
  } catch {}
}
